// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cls-popup-back {
  position: fixed;
  left: 0;
  bottom: 150px;
  width: 100%;
  display: none;
  justify-content: center;
  z-index: 10011111110101;
  -webkit-user-select: none;
          user-select: none;
}

.cls-popup-content {
  text-align: center;
  background-color: #3d4152;
  max-width: 350px;
  color: #fff;
  position: absolute;
  margin: 0 0 6px;
  padding: 15px;
  border-radius: 3px 3px 3px 3px;
  background-position: 15px center;
  background-repeat: no-repeat;
  box-shadow: 0 0 12px #514b4b;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
  filter: alpha(opacity=80);
  transition: opacity 2s ease 0.15s;
  opacity: 0;
  -webkit-user-select: none;
          user-select: none;
  word-break: break-word;
}

.cls-popup-content.active {
  opacity: 1;
  word-break: break-word;
}

.success {
  background-color: #51a351;
}

.info {
  background-color: #2f96b4;
}

.pop-icon-div {
  padding: 0;
  -webkit-user-select: none;
          user-select: none;
}

.pop-message {
  display: inline-block;
  word-wrap: break-word;
  font-size: 15px;
  line-height: 20px;
  -webkit-user-select: none;
          user-select: none;
  word-break: break-word;
}

.active_flex {
  display: flex;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
